<template>
  <div id="remove-form-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">DELETE FORM</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <vue-spinner v-if="loading"></vue-spinner>
              <p v-else>Are you sure you would like to delete this form?</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn green" @click.prevent="removeForm">Yes</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Spinner from "../../Spinner";
  import {HTTP, ERROR} from '@/http-common';

  export default {
    name: 'RemoveFormModal',
    components: {
      VueSpinner : Spinner
    },
    props: ['formId'],
    data() {
      return {
        loading: false
      }
    },
    mounted() {
      $('#remove-form-modal').modal('show');
      $('#remove-form-modal').on('hidden.bs.modal', () => {
        this.$emit('display', false);
      });
    },
    methods: {
      removeForm() {
          this.loading = true;
          HTTP.post('/form/delete', {id: this.formId})
            .then(response => {
              ERROR(response);
              if (response.data.status === 'success') {
                this.loading = false;
                this.$emit('form-removed', this.formId);
                this.$emit('display', false);
                $('#remove-form-modal').modal('hide');
              } else {
                this.loading = false;
                this.$notify({
                  type: 'error',
                  text: response.data.hasOwnProperty('message') ? response.data.message : 'Something went wrong while trying to remove form.'
                });
                this.$emit('display', false);
                $('#remove-form-modal').modal('hide');
              }
            })
            .catch(err => {
              this.$notify({
                type: 'error',
                text: 'Something went wrong while trying to remove form.'
              });
              $('#remove-form-modal').modal('hide');
              this.$emit('display', false);
            });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// RemoveFormModal.vue?18164aec